import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class DownloadNav extends BLComponent {
	constructor (props) {
		super(props);
	}

	render() {
		const {page} = this.props;

		return (
			<div className={"container studio-download__internal-nav-container"}>
				<div className="container__internal">
					<div className="studio-download__internal-nav">
						{page == 1 ? <strong className="studio-download__internal-nav-item studio-download__internal-nav-item--active"><img src={`//${blapp.config.getHost( "static2" )}/img/studio-download-nav/studio.svg`} alt="Studio Logo"/>Studio</strong> : <a href={blapp.url2.getStudioDownloadUrl()} className="studio-download__internal-nav-item"><img src={`//${blapp.config.getHost( "static2" )}/img/studio-download-nav/studio-ghost.svg`} alt="Studio Logo Outline"/>Studio</a>}
						{page == 2 ? <strong className="studio-download__internal-nav-item studio-download__internal-nav-item--active"><img src={`//${blapp.config.getHost( "static2" )}/img/studio-download-nav/early-access.svg`} alt="Early Access Logo"/>Early Access</strong> : <a href={blapp.url2.getEarlyAccessDownloadUrl()} className="studio-download__internal-nav-item"><img src={`//${blapp.config.getHost( "static2" )}/img/studio-download-nav/early-access-ghost.svg`} alt="Studio Early Access Logo Outline"/>Early Access</a>}
						{page == 3 ? <strong className="studio-download__internal-nav-item studio-download__internal-nav-item--active"><img src={`//${blapp.config.getHost( "static2" )}/img/studio-download-nav/part-designer.svg`} alt="PartDesigner Logo"/>PartDesigner</strong> : <a href={blapp.url2.getPartDesignerDownloadUrl()} className="studio-download__internal-nav-item"><img src={`//${blapp.config.getHost( "static2" )}/img/studio-download-nav/part-designer-ghost.svg`} alt="PartDesigner Logo Outline"/>PartDesigner</a>}
					</div>
				</div>
			</div>
		);
	}
}